/**
 * 在 dragstart 事件中使用，为全屏叠加一个箭头线条，表现出
 */
export const startDragLinkingLine = ({
  startX,
  startY,
  lineClassName = 'ucd-bindingLine'
}) => {
  const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  svg.setAttributeNS(null, 'width', `${window.innerWidth}px`);
  svg.setAttributeNS(null, 'height', `${window.innerHeight}px`);
  svg.setAttributeNS(null, 'style', 'position:fixed;left:0;top:0;pointer-events:none;z-index:10000');
  const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
  const dStart = `M${startX},${startY}`;
  path.setAttributeNS(null, 'class', lineClassName);
  path.setAttributeNS(null, 'fill', 'transparent');
  path.setAttributeNS(null, 'stroke-width', 2);
  path.setAttributeNS(null, 'd', dStart);
  svg.appendChild(path);
  document.body.appendChild(svg);
  function updateLine({
    clientX,
    clientY
  }) {
    const centerX = (startX + clientX) / 2;
    path.setAttributeNS(null, 'd', `${dStart} C${centerX} ${startY},${centerX} ${clientY}, ${clientX} ${clientY}`);
  }
  function dispose() {
    window.removeEventListener('mousemove', updateLine, true);
    window.removeEventListener('dragover', updateLine, true);
    window.removeEventListener('mouseup', dispose, true);
    window.removeEventListener('dragend', dispose, true);
    document.body.removeChild(svg);
  }
  window.addEventListener('mousemove', updateLine, true);
  window.addEventListener('dragover', updateLine, true);
  window.addEventListener('mouseup', dispose, true);
  window.addEventListener('dragend', dispose, true);
};
//# sourceMappingURL=startDragLinkingLine.js.map
